import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { CardCarouselWrapper } from '../CardCarouselWrapper';
import { Section } from '../Section';
import { Spacer } from '../Spacer';
import { PropertyCard } from './PropertyCard';

interface RecentPropertiesCarouselProps {
  rentalProperties: any[];
  resaleProperties: any[];
  searchRentUrl: string;
  searchSaleUrl: string;
  searchType: string;
}

interface StyledPros {
  isActive?: boolean;
}

// Styles
const StyledToggleCarousel = styled.div`
  ${({ theme: { space } }) => css`
    display: flex;

    gap: ${space.sm};
  `};
`;
const StyledToggleCarouselCta = styled.button<StyledPros>`
  ${({ theme: { space, colors, global }, isActive }) => css`
    border: 1px solid ${colors.grey2.default};
    border-radius: ${global.borderRadius.default};
    padding: ${space.sm} ${space.lg};
    position: relative;
    font-weight: 700;
    min-width: 144px;
    ${isActive &&
    css`
      background-color: ${colors.brand.default};
      color: ${colors.white.default};

      &:hover {
        background-color: ${colors.brand.default};
        color: ${colors.white};
      }
    `};
  `};
`;

const StyledToggleCarouselCtaFooter = styled.div`
  display: flex;
  /* justify-content: center; */
`;

export const RecentPropertiesCarousel = ({
  rentalProperties,
  resaleProperties,
  searchRentUrl,
  searchSaleUrl,
  searchType,
}: RecentPropertiesCarouselProps) => {
  const [propertiesCarousel, setPropertiesCarousel] = useState(rentalProperties);
  const [mode, setMode] = useState(rentalProperties?.length > 2 ? 'rent' : 'buy');

  useEffect(() => {
    if (mode === 'rent') {
      setPropertiesCarousel(rentalProperties);
    } else if (mode === 'buy') {
      setPropertiesCarousel(resaleProperties);
    }
  }, [mode, rentalProperties, resaleProperties]);

  const hasEnoughProperties = rentalProperties?.length > 2 || resaleProperties?.length > 2;

  if (!hasEnoughProperties) {
    return null;
  }

  return (
    <Section contained dontPrint overflowHidden>
      <Spacer responsive>
        <CardCarouselWrapper
          heading="Recently added properties"
          component={
            <>
              {rentalProperties?.length > 2 && resaleProperties.length > 2 && (
                <StyledToggleCarousel>
                  <StyledToggleCarouselCta isActive={mode === 'rent'} onClick={() => setMode('rent')}>
                    Rent
                  </StyledToggleCarouselCta>
                  <StyledToggleCarouselCta isActive={mode === 'buy'} onClick={() => setMode('buy')}>
                    Buy
                  </StyledToggleCarouselCta>
                </StyledToggleCarousel>
              )}
            </>
          }
        >
          {propertiesCarousel?.map((property, index: number) => (
            <PropertyCard
              property={property?.node || property}
              vertical
              onWhiteBg
              key={`rv-${property?.node?.id}`}
              unSaveable
              prioritiseViewing
              clickSection="property carousel branches"
              displayMobileCta
              hidePrice
              position={index + 1}
            />
          ))}
        </CardCarouselWrapper>
        <StyledToggleCarouselCtaFooter>
          <Button url={mode === 'rent' ? searchRentUrl : searchSaleUrl} variant="outline" arrowRight>
            All {searchType} properties to {mode}
          </Button>
        </StyledToggleCarouselCtaFooter>
      </Spacer>
    </Section>
  );
};
